module.exports = __webpack_public_path__ + "static/img/index7.96dc737.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index7.gif
// module id = crKo
// module chunks = 0